
<div class="row" style="margin-top: 0.5rem;">
  <div class="col-sm-12 col-md-6">
    <div class="form-group">
      <label class="lbl" [for]="jobNameLBL">{{orderLblText.jobNameLbl?orderLblText.jobNameLbl:orderdetailsLbl.jobNameLbl}}<span class="requiredField">*</span> </label>

      <input type="search" kendoTextBox id="jobNameId"
             [(ngModel)]="orderdetail.jobName" #jobNameLBL
             (ngModelChange)="onJobNameChange($event)"
             (blur)="validateForm()"
             [ngClass]="{warningErrorBorder : orderDetailsForm?.isInvalidJobName && orderDetailsForm?.isSubmitted }"
             class="kendoInput" [maxlength]="30"
             tabindex="1"
             (search)="crossIconClick()"
             (input)="onJobNameInput($event)" />
      <div class="searchIcon" (click)="toggleJobSearchDialog()">
        <span class="k-icon k-i-search"></span>
      </div>
    </div>
    <div class="form-group">
      <label class="lbl" [for]="jobCityLBL">{{orderLblText.jobCityLbl?orderLblText.jobCityLbl:orderdetailsLbl.jobCityLbl}}<span class="requiredField">*</span> </label>
      <input kendoTextBox [(ngModel)]="orderdetail.jobCity"
             #jobCityLBL
             (blur)="validateForm()"
             class="kendoInput"
             [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidJobCity && orderDetailsForm.isSubmitted }"
             [maxlength]="25"
             tabindex="2"
             [disabled]="jobCityDisabled" />
    </div>
    <div class="form-group">
      <label class="lbl" [for]="jobStateLBL">{{orderLblText.jobStateLbl?orderLblText.jobStateLbl:orderdetailsLbl.jobStateLbl}}<span class="requiredField">*</span> </label>
      <kendo-dropdownlist class="kendoInput" #jobStateLBL
                          [(ngModel)]="orderdetail.jobState"
                          [data]="data"
                          (valueChange)="jobStateChange($event)"
                          [filterable]="true"
                          textField="stateDescription"
                          valueField="stateDescription"
                          [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidJobState && orderDetailsForm.isSubmitted }"
                          tabindex="3"
                          (filterChange)="handleStatesFilterChange($event)">
      </kendo-dropdownlist>
    </div>
    <div class="form-group">
      <label class="lbl" [for]="poLBL">{{orderLblText.poLbl?orderLblText.poLbl:orderdetailsLbl.poLbl}}<span class="requiredField">*</span> </label>
      <input kendoTextBox [(ngModel)]="orderdetail.po"
             #poLBL (blur)="validateForm()"
             (ngModelChange)="onPoNameChange($event)"
             class="kendoInput"
             [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidPO && orderDetailsForm.isSubmitted }"
             maxlength="30"
             tabindex="4"
             (input)="onPoInput($event)" />
    </div>
    <div class="form-group">
      <label class="lbl" [for]="marketSegmentLBL">{{orderLblText.marketSegmentLbl?orderLblText.marketSegmentLbl:orderdetailsLbl.marketSegmentLbl}}<span class="requiredField">*</span> </label>
      <kendo-dropdownlist class="kendoInput" #marketSegmentLBL
                          [(ngModel)]="orderdetail.marketSegment"
                          [data]="marketSegments"
                          (valueChange)="marketSegmentChange($event)"
                          textField="name"
                          valueField="value"
                          [filterable]='false'
                          [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidMarketSegment && orderDetailsForm.isSubmitted }"
                          tabindex="5">
      </kendo-dropdownlist>
    </div>
    <div class="form-group">
      <label class="lbl" for="frieghtTermsLBL">{{orderLblText.frieghtTermsLbl?orderLblText.frieghtTermsLbl:orderdetailsLbl.frieghtTermsLbl}}<span class="requiredField">*</span> </label>
    </div>
    <div *ngIf="freightEstimateFlag" class="freightTermsSection"
         [ngClass]="{warningErrorBorder : orderDetailsForm.isFreightCalcIncomplete && orderDetailsForm.isSubmitted }">
      <kendo-dropdownlist class="kendoInput" #frieghtTermsLBL  [popupSettings]="{popupClass:'freight-popup'}"
                          [(ngModel)]="orderdetail.freightTerms"
                          [data]="getFreightTerms$ | async"
                          (valueChange)="selectfrieghtTerms($event)"
                          textField="name"
                          valueField="value"
                          [filterable]='false'
                          [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidFreightTerms && orderDetailsForm.isSubmitted }"
                          tabindex="6">
      </kendo-dropdownlist>
    </div>
    <div [ngClass]="form-group" *ngIf="this.freightTermSelection ==2">
      <label class="lbl" [for]="frightNotesLBL">{{orderLblText.frightNotesLbl?orderLblText.frightNotesLbl:orderdetailsLbl.frightNotesLbl}}<span class="requiredField">*</span></label>
      <input kendoTextBox [(ngModel)]="orderdetail.freightNotes" #frightNotesLBL (blur)="validateForm()"
             [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidFreightNotes && orderDetailsForm.isSubmitted }"
             class="kendoInput" [maxlength]="30" tabindex="17" />
    </div>
    <div *ngIf="this.freightTermSelection ==1" [ngClass]="(orderdetail.taxable == 'DEFAULT' || orderdetail.taxable == 'YES'?'form-group LeftCls topCls':'form-group LeftCls topCls1')">
      <kendo-switch [(ngModel)]="this.checkoutService.prepaidFreightSelected" #includeFreightLbl (valueChange)="SwitchFrieghtInclude($event)" [onLabel]="'Yes'" [offLabel]="'No'"
                    tabindex="15"></kendo-switch>
      <label class="lblPad" style="margin-left:5px;" [for]="includeFreightLBL">{{orderLblText.includeFreightLbl?orderLblText.includeFreightLbl:orderdetailsLbl.includeFreightLbl}}</label>
      <span title="{{orderLblText.includeFreightTitlelbl?orderLblText.includeFreightTitlelbl:orderdetailsLbl.includeFreightTitlelbl}}"
            class="k-icon k-i-information k-i-info spanInfoIconCls" kendoTooltip
            style="color:black;font-weight:600;margin-left:5px;"></span>
      <kendo-loader *ngIf="freightCalcInProgress" style="color:blue"></kendo-loader>
      <!--*Retry If Applicable-->
      <button [icon]="'refresh'" *ngIf="this.orderdetail.freightTerms.value==1 && this.checkoutService.prepaidFreightSelected && isRetry && !freightCalcInProgress" (click)="selectfrieghtTerms(4)" class="btn-success" kendoButton>
        Retry
      </button>
      &nbsp;&nbsp;&nbsp;
      <span *ngIf="this.orderdetail.freightTerms.value==1 && this.checkoutService.prepaidFreightSelected && !freightCalcInProgress">${{this.checkoutService.checkOutProcessModel.freightAmount}}</span>
      <span style="color:red;" *ngIf="isFreightTermsError">{{isFreightTermsErrorMsg}}, you can select <b>PrePaid</b>,<b>Collect</b> or <b>Pickup</b> as an alternative option.</span>

    </div>

    <div class="form-group" *ngIf="!freightEstimateFlag">
      <kendo-dropdownlist class="kendoInput" #frieghtTermsLBL
                          [(ngModel)]="orderdetail.freightTerms"
                          [data]="getFreightTerms$ | async"
                          (valueChange)="freightTermsChange($event)"
                          textField="name"
                          valueField="value"
                          [filterable]='false'
                          [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidFreightTerms && orderDetailsForm.isSubmitted }"
                          tabindex="6">
      </kendo-dropdownlist>

    </div>
    <div class="form-group" style="width: 108%;">
      <div class="row">
        <div class="col-md-4">
          <label class="lbl" [for]="requestDateLBL">{{orderLblText.requestDateLbl?orderLblText.requestDateLbl:orderdetailsLbl.requestDateLbl}} </label>
          <kendo-datepicker class="kendoInput" [(ngModel)]="orderdetail.requestDate"
                            placeholder="MM/DD/YYYY"
                            #requestDateLBL format="MM/dd/yyyy"
                            [min]="minRequestDate"
                            [max]="maxRequestDate"
                            (focusout)="checkRequestDate()"
                            (blur)="checkRequestDateType()"
                            (keydown)="onDateKeyDown($event)"
                            [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidRequestDate && orderDetailsForm.isSubmitted }"
                            [formatPlaceholder]="{year: 'YYYY', month: 'MM', day: 'DD'}" tabindex="7">
          </kendo-datepicker>
        </div>
        <div class="col-md-4">
          <label class="lbl" for="requestDateTypeLbl">{{orderLblText.requestDateTypeLbl?orderLblText.requestDateTypeLbl:orderdetailsLbl.requestDateTypeLbl}}
            <span *ngIf="!isRequestTypeDisable" class="requiredField">*</span></label>
          <kendo-dropdownlist #requestDateTypeDropdown [data]="RequestDateTypeDropdwon"
                              [textField]="'name'" [valueField]="'value'"
                              (selectionChange)="requestDateTypeChange($event)"
                              [disabled]="isRequestTypeDisable"
                              [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidRequestDateType && orderDetailsForm.isSubmitted }"
                              [ngModel]="{name:selectedRequestDateType,value:selectedRequestDateTypeval}" class="kendoInput"
                              tabindex="8">
          </kendo-dropdownlist>
        </div>
        <div class="col-md-4">
          <label class="lbl" for="shipCompleteLbl">{{orderLblText.shipCompleteLbl?orderLblText.shipCompleteLbl:orderdetailsLbl.shipCompleteLbl}} </label>
          <kendo-dropdownlist [data]="shipCompleteDropdwon"
                              [textField]="'name'" [valueField]="'value'"
                              (selectionChange)="shipCompleteChange($event)"
                              [ngModel]="{name:shipCompleteType,value:shipCompleteTypeval}" class="kendoInput"
                              tabindex="9">
          </kendo-dropdownlist>
        </div>
      </div>
        
      </div>
      <div class="form-group">
        <label class="lbl" for="confirmEmailLbl">{{orderLblText.confirmEmailLbl?orderLblText.confirmEmailLbl:orderdetailsLbl.confirmEmailLbl}} </label>
        <kendo-multiselect [data]="sizes" [value]="selectedSizes" [(ngModel)]="orderdetail.confirmEmail"
                           [allowCustom]="true" no-data-template="false" tabindex="10" [popupSettings]="{ height: dynamicHeight }"
                           [listHeight]="dynamicHeight" (valueChange)="checkConfirmEmail($event)" [ngClass]="{'confirm-email-class':isEmailFormatInvalid}">
          <ng-template kendoMultiSelectNoDataTemplate hidden let-dataItem>
          </ng-template>
        </kendo-multiselect>
        <span title="{{orderLblText.invalidConfirmEmail?orderLblText.invalidConfirmEmail:orderdetailsLbl.invalidConfirmEmail}}" *ngIf="isEmailFormatInvalid" kendoTooltip
              class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
      </div>
      <!--hiding promo code section-->
      <!--<div style="float:left;">
    <kendo-switch [(ngModel)]="orderdetail.promoCodeCheck" #promoCodeLbl [onLabel]="'Yes'" [offLabel]="'No'"
                  class="activeSwitchCls">
    </kendo-switch>
    <label class="lblPad" [for]="promoCodeLbl">
      {{orderLblText.promoCodeLbl?orderLblText.promoCodeLbl:orderdetailsLbl.promoCodeLbl}}
    </label>
  </div>
  <div class="form-group" *ngIf="orderdetail.promoCodeCheck">
    <input kendoTextBox [(ngModel)]="orderdetail.promoCode" class="txt-size"
           [ngClass]="{'borderRed':isEmptyPromoCode && isPromoApply}" (blur)="validatePromoCode()" />
    <button class="btn btn-success btn-size" kendoButton (click)="applyPromoCode()">
      {{orderLblText.promoApplyLbl?orderLblText.promoApplyLbl:orderdetailsLbl.promoApplyLbl}}

    </button>
    <span style="float: left;color: green; width: 10%;" *ngIf="isValidPromoCode">
      {{textdescription}}
    </span>
    <span style="float:left;color:green" *ngIf="isValidPromoCode">
      {{textMessage}}
    </span>
    <span style="float:left; color:red" *ngIf="!isValidPromoCode">
      {{textMessage}}
    </span>
  </div>-->



    </div>
    <div class="col-sm-12 col-md-6 rightSideDiv">
      <div class="form-group LeftCls">
        <input type="checkbox" class="k-checkbox checkboxSize" id="leed" (change)="selectLeed()" [(ngModel)]="orderdetail.leed" tabindex="11" />
        <label class="lblPad" [for]="leed">
          {{orderLblText.leedLbl?orderLblText.leedLbl:orderdetailsLbl.leedLbl}}
          <!--<kendo-loader *ngIf="freightLeedInProcess" style="color:blue"></kendo-loader>-->
        </label>
      </div>

      <!--<div>
     <div class="form-group taxableCls LeftCls">
       <span #taxableInfo>
         <kendo-dropdownlist class="kendoInput" #taxableLBL
                             [defaultItem]="defaultItem"
                             [data]="taxableData"
                             textField="text"
                             valueField="value"
                             [filterable]='false'
                             (valueChange)="taxableChange($event)"
                             tabindex="10" style="width: 150px;">
           >
         </kendo-dropdownlist>
         <span class="lblPad">
           <label class="lbl" [for]="taxableLBL" style="padding-right:5px;">{{orderLblText.taxableLbl?orderLblText.taxableLbl:orderdetailsLbl.taxableLbl}} </label>
           <span *ngIf="orderdetail.taxable == 'NO'">&nbsp;</span>
           <span *ngIf="orderdetail.taxable == 'NO'" class="k-icon k-i-info" (click)="taxableInfoToggle()" title="{{inputTax}}"></span>
           <kendo-popup #popup [anchor]="taxableInfo" *ngIf="showInfo"
                        (anchorViewportLeave)="showInfo = false">
             <span class="popupCss">
               {{inputTax}}
             </span>
           </kendo-popup>
         </span>
         <!--<span #taxableInfo>
      <kendo-switch [(ngModel)]="orderdetail.taxable" #taxableLBL [onLabel]="'Yes'"
    [offLabel]="'No'" tabindex="10"></kendo-switch>

      <span class="lblPad">
        <label [for]="taxableLBL">{{taxableLbl}} </label>
        <span *ngIf="!taxable">&nbsp;</span>
        <span *ngIf="!taxable" class="k-icon k-i-info" (click)="taxableInfoToggle()" title="{{inputTax}}"></span>
        <kendo-popup #popup [anchor]="taxableInfo" *ngIf="showInfo && !taxable"
                     (anchorViewportLeave)="showInfo = false">
          <span class="popupCss">
            {{inputTax}}
          </span>
        </kendo-popup>
      </span>
    </span>
      </span>
    </div>
        <div class="form-group">
          <input kendoTextBox [(ngModel)]="orderdetail.taxableCertification"
                 placeholder="{{orderLblText.taxableCertificationLbl?orderLblText.taxableCertificationLbl:orderdetailsLbl.taxableCertificationLbl}}" class="kendoInput bottomMargin"
                 [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidTaxableCertification && orderDetailsForm.isSubmitted }"
                 *ngIf="orderdetail.taxable == 'NO'" tabindex="11">
        </div>
        <div class="form-group uploadCls">
          <!--<input type="file" class="k-button btn" style="width: 100%;" name="fileupload" #fileupload [(ngModel)]="orderdetail.file"
         [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidMyFiles && orderDetailsForm.isSubmitted }" required
         *ngIf="orderdetail.taxable == 'NO'" tabindex="12" (change)="handleFileInput($event.target.files)">
          <app-upload [multiple]="false" (fileSelect)="fileSelected($event)" [uploadFolderPath]="'TempDocs\\TaxDoc'" *ngIf="orderdetail.taxable == 'NO'" tabindex="12"
                      (uploadSuccess)="uploadSuccess($event)" (uploadComplete)="uploadComplete()" [fileRestrictions]="fileRestrictions" [myFiles]="myFiles"
                      (uploadRemove)="uploadRemove($event)"></app-upload>
        </div>
      </div>-->
      <div class="form-group LeftCls">
        <button (click)="toggletaxCertificatesDialog()" class="btn-success" kendoButton>
          {{orderLblText.taxablebuttonlbl?orderLblText.taxablebuttonlbl:orderdetailsLbl.taxablebuttonlbl}}
        </button>
        <span title="{{orderLblText.taxabletitlelbl?orderLblText.taxabletitlelbl:orderdetailsLbl.taxabletitlelbl}}"
              class="k-icon k-i-information k-i-info spanInfoIconCls" kendoTooltip
              style="color:black;font-weight:600"></span>
      </div>
      <div [ngClass]="(orderdetail.taxable == 'DEFAULT' || orderdetail.taxable == 'YES'?'form-group LeftCls topCls':'form-group LeftCls topCls1')">
        <kendo-switch [(ngModel)]="orderdetail.quotedInHouse" #quotedInHouseLBL [onLabel]="'Yes'" [offLabel]="'No'"
                      tabindex="15"></kendo-switch>
        <label class="lblPad" [for]="quotedInHouseLBL">{{orderLblText.quotedInHouseLbl?orderLblText.quotedInHouseLbl:orderdetailsLbl.quotedInHouseLbl}}</label>
      </div>

      <div [ngClass]="(orderdetail.taxable == 'DEFAULT' || orderdetail.taxable == 'YES'?'form-group topCls':'form-group topCls1')"
           *ngIf="orderdetail.quotedInHouse">
        <input kendoTextBox [(ngModel)]="orderdetail.quoteNumber"
               [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidQuoteNumber && orderDetailsForm.isSubmitted }"
               placeholder="{{quoteNumberLbl}}" class="kendoInput"
               [maxlength]="30" tabindex="16" />
        <!-- (keyup)="quoteNumberFormat(orderdetail.quoteNumber)"  -->
      </div>
      <div *ngIf="!freightEstimateFlag" [ngClass]="(orderdetail.quotedInHouse===true?'form-group':'form-group freightNoteCls')">
        <label class="lbl" [for]="frightNotesLBL">{{orderLblText.frightNotesLbl?orderLblText.frightNotesLbl:orderdetailsLbl.frightNotesLbl}} </label>
        <input kendoTextBox [(ngModel)]="orderdetail.freightNotes" #frightNotesLBL
               [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidFreightNotes && orderDetailsForm.isSubmitted }"
               class="kendoInput" [maxlength]="30" tabindex="17" />
      </div>
      <div class="form-group">
        <label class="lbl" [for]="commentsLBL">{{orderLblText.commentsLbl1?orderLblText.commentsLbl1:orderdetailsLbl.commentsLbl1}} </label>
        <textarea kendoTextArea #commentsLBL class="kendoInput textArea" [maxlength]="maxChars"
                  [(ngModel)]="orderdetail.comments" (keyup)="commenttxtArea($event)"
                  [ngClass]="{warningErrorBorder : orderDetailsForm.isInvalidComments && orderDetailsForm.isSubmitted }"
                  placeholder="{{orderLblText.commentsLbl2?orderLblText.commentsLbl2:orderdetailsLbl.commentsLbl2}}" tabindex="18"></textarea>
        <div class="LeftCls"> {{orderLblText.characterRemainingLbl?orderLblText.characterRemainingLbl:orderdetailsLbl.characterRemainingLbl}}: {{commentslength}}/{{maxChars}}</div>
      </div>
    </div>
    &nbsp;
    <div class=" col-sm-12 col-lg-12 col-md-12" *ngIf="showCreditSection" id="hiddentoModifyCreditLbl">
      <div class="creditInformationDiv">
        <!--<div class="creditHeader">{{orderLblText.defaultCreditInfoLbl?orderLblText.defaultCreditInfoLbl:creditInfoLabel.defaultCreditInfoLbl}}</div>-->
        <div class="creditSubHeader" id="hiddentoModifyCreditLbl">{{orderLblText.toModifyCreditLbl?orderLblText.toModifyCreditLbl:creditInfoLabel.toModifyCreditLbl}}</div>
        <div class="row" id="hiddentoModifyCreditLbl">
          <div class="col-sm-6 paddingLeftZero">
            <div class="row creditLeftCls">
              <div class="col-12 paddingLeftZero">
                <span>{{orderLblText.payByCreditLbl?orderLblText.payByCreditLbl:creditInfoLabel.payByCreditLbl}}</span>&nbsp;
                <kendo-switch [(ngModel)]="orderdetail.useCreditCard" [onLabel]="'Yes'" [offLabel]="'No'"
                              (click)="useCreditCard(orderdetail.useCreditCard)">
                </kendo-switch>
              </div>
            </div>


          </div>
        </div>
        <!--<div class="row" *ngIf="showCreditCardDetails">
        <div class="col-12 paddingLeftZero">
          <div class="row creditLeftCls">
            <div class="col-12 paddingLeftZero">
              <span>{{orderLblText.cardTypeLbl?orderLblText.cardTypeLbl:creditInfoLabel.cardTypeLbl}}</span>&nbsp;
              <span>{{creditInfoLabel.cardTypeText}}</span>
            </div>
            <div class="col-12 paddingLeftZero">
              <span>{{orderLblText.nameOnCardLbl?orderLblText.nameOnCardLbl:creditInfoLabel.nameOnCardLbl}}</span>&nbsp;
              <span>{{creditInfoLabel.nameOnCardText}}</span>
            </div>
            <div class="col-12 paddingLeftZero">
              <span>{{orderLblText.creditCardNumberLbl?orderLblText.creditCardNumberLbl:creditInfoLabel.creditCardNumberLbl}}</span>&nbsp;
              <span>{{creditInfoLabel.cardNumberText}}</span>
            </div>
            <div class="col-12 paddingLeftZero">
              <span>{{orderLblText.cardExpiryLbl?orderLblText.cardExpiryLbl:creditInfoLabel.cardExpiryLbl}}</span>&nbsp;
              <span>{{creditInfoLabel.expirationMonth}}/{{creditInfoLabel.expirationYear}}</span>
            </div>

          </div>

        </div>
      </div>-->
      </div>
    </div>

    <section class="dialogSection">
      <kendo-dialog title="{{orderLblText.jobSearchHeadingLbl?orderLblText.jobSearchHeadingLbl:orderdetailsLbl.jobSearchHeadingLbl}}" *ngIf="jobNameDialog.opened" (close)="toggleJobSearchDialog()">
        <div class="container-fluid paddingZero">
          <form [formGroup]="jobNameForm">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">

                  <label class="lbl">
                    {{orderLblText.jobNumberLbl?orderLblText.jobNumberLbl:orderdetailsLbl.jobNumberLbl}}
                  </label>
                  <input type="text" kendoTextBox class="form-control" name="jobNumber" formControlName="jobNumber" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="lbl">
                    {{orderLblText.jobNameLbl?orderLblText.jobNameLbl:orderdetailsLbl.jobNameLbl}}
                  </label>
                  <input type="text" kendoTextBox class="form-control" name="jobName" formControlName="jobName" [maxlength]="30" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">

                  <label class="lbl">
                    {{orderLblText.jobCityLbl?orderLblText.jobCityLbl:orderdetailsLbl.jobCityLbl}}
                  </label>

                  <input type="text" kendoTextBox class="form-control" name="city" formControlName="jobCity" [maxlength]="30" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">

                  <label class="lbl">
                    {{orderLblText.jobStateLbl?orderLblText.jobStateLbl:orderdetailsLbl.jobStateLbl}}
                  </label>

                  <kendo-dropdownlist [data]="data" style="padding-left:0px;"
                                      class="form-control"
                                      [textField]="'stateDescription'"
                                      [valueField]="'stateCode'"
                                      name="state"
                                      formControlName="jobState"
                                      [valuePrimitive]="true">
                  </kendo-dropdownlist>
                </div>
              </div>
            </div>


            <div class="row" style="text-align:center">
              <button (click)="SearchJobName()" class="m-3 btn btn-success dialogBtnSize" kendoButton>
                {{orderLblText.jobSearchBtnLbl?orderLblText.jobSearchBtnLbl:orderdetailsLbl.jobSearchBtnLbl}}
              </button>
            </div>
          </form>
        </div>

        <div *ngIf="showJobNameListGrid">
          <kendo-grid [data]="jobSearchGridData" [height]="230" [sortable]="true" [navigable]="true" [filterable]="false"
                      [groupable]="false" [reorderable]="true" [resizable]="false" [sort]="jobSearchGridState.sort"
                      (sortChange)="jobSearchGridSortChange($event)" [pageable]="{ buttonCount: 5, info: true }"
                      [pageSize]="jobSearchGridState.take" [skip]="jobSearchGridState.skip" [columnMenu]="false"
                      (pageChange)="jobSearchGridPageChange($event)" (dataStateChange)="jobSearchGridDataStateChange($event)"
                      [filter]="jobSearchGridState.filter" [loading]="jobSearchGridSettings.gridLoading" [selectable]="false">

            <kendo-grid-column [width]="30" [filterable]="false">
              <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <input type="radio" kendoRadioButton id="{{dataItem.id}}"
                       [checked]="dataItem.isSelected===true? true: false" (change)="selectJobName(dataItem,rowIndex)" />
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="jobNumber" title="{{orderLblText.jobNumberLbl?orderLblText.jobNumberLbl:orderdetailsLbl.jobNumberLbl}}" [width]="90">
            </kendo-grid-column>
            <kendo-grid-column field="jobName" title="{{orderLblText.jobNameLbl?orderLblText.jobNameLbl:orderdetailsLbl.jobNameLbl}}" [width]="140">
            </kendo-grid-column>
            <kendo-grid-column field="city" title="{{orderLblText.jobCityLbl?orderLblText.jobCityLbl:orderdetailsLbl.jobCityLbl}}" [columnMenu]="false" [width]="100">
            </kendo-grid-column>

            <kendo-grid-column field="state" title="{{orderLblText.jobStateLbl?orderLblText.jobStateLbl:orderdetailsLbl.jobStateLbl}}" [columnMenu]="false" [width]="100"
                               [filterable]="true" [editable]="false">
            </kendo-grid-column>

            <!--Need to modify while doing pagination-->
            <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
              <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
              <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
              <kendo-pager-info></kendo-pager-info>
              <kendo-pager-next-buttons></kendo-pager-next-buttons>
              <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
            </ng-template>
          </kendo-grid>
          <div style="text-align:center">
            <button (click)="addJobDetails()" class="m-3 clearKendoButton btn btnGreenBorderCls dialogBtnSize"
                    kendoButton>
              {{orderLblText.addJobLbl?orderLblText.addJobLbl:orderdetailsLbl.addJobLbl}}
            </button>
          </div>
        </div>
      </kendo-dialog>

    </section>
    <section class="dialogsection">
      <!--KENDO POP UP FOR TAX CERTIFICATE SELECTION START-->
      <!--KENDO POP UP FOR TAX CERTIFICATE SELECTION START-->
      <kendo-dialog title="{{orderLblText.taxCertifiactetitletxt?orderLblText.taxCertifiactetitletxt:orderdetailsLbl.taxCertifiactetitletxt}}"
                    style="min-width:500px;" *ngIf="taxCertificatesDialog.opened" (close)="toggletaxCertificatesDialog()">
        <div style="max-width:500px;">
          <form class="k-form" [formGroup]="taxCertificateForm" style="padding: 0px ! important;">

            <div style="text-align:center"><b>{{orderLblText.taxCertifiacteddlheadertxt?orderLblText.taxCertifiacteddlheadertxt:orderdetailsLbl.taxCertifiacteddlheadertxt}}</b></div>
            <br />
            <div class="col-md-12">
              <kendo-dropdownlist style="margin-left: 35px;" class="txt-size"
                                  [data]="filteredTaxCertificatesItems"
                                  [textField]="'name'"
                                  [filterable]="true"
                                  [valueField]="'id'"
                                  (selectionChange)="taxCertificateChangeSelected($event)"
                                  (close)="onCloseCertificateChange($event)"
                                  (filterChange)="handleTaxCertificateFilter($event)">
              </kendo-dropdownlist>
              <br />
              <br />
              <span> {{orderLblText.taxCertifiactenotelbl?orderLblText.taxCertifiactenotelbl:orderdetailsLbl.taxCertifiactenotelbl}} </span>
            </div>
            <br />
            <br />
            <div style="text-align:center">
              <button kendoButton class="btn-success"
                      (click)="addCertificatesCommentSubmit()" [disabled]="!taxCertificatesDialog.valid">
                {{orderLblText.taxCertifiactebtntxt?orderLblText.taxCertifiactebtntxt:orderdetailsLbl.taxCertifiactebtntxt}}
              </button>
              &nbsp;
              <button kendoButton (click)="toggletaxCertificatesDialog()">
                Cancel
              </button>
            </div>
          </form>
        </div>
      </kendo-dialog>
      <!--KENDO POP UP FOR TAX CERTIFICATE SELECTION END-->
    </section>

  </div>
<div class="row" *ngIf="freightEstimateNoteFlag && this.checkoutService.prepaidFreightSelected">
  <div class="col-sm-12 col-md-12">
    {{shippingDevNote}}
  </div>
</div>
